const PreviousIcon = () => {
  return (
    <svg width="10" height="13" viewBox="0 0 7 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.6665 10L0.666504 5L5.6665 0L6.83317 1.16667L2.99984 5L6.83317 8.83333L5.6665 10Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default PreviousIcon;
